import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Button trimmed to fit a dense grid cell: no min width, small type, 8px block padding. */
export const CompactButton = styled(Button)(({ theme }) => ({
  minWidth: 'auto',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  fontSize: '0.75rem',
}));
